import { t } from "@/i18n-js/instance";
import { BlockListItem } from "../BlockListItem";

export const BannerItem = () => (
  <BlockListItem icon="16-video-block" label={t("courses.lockscreen.banner")} />
);
